import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  root: {
    margin: '2rem 0',
  },
}));
